import {
  vBoolean,
  vNonEmptyString,
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const confirmLoadSchema = vObject({
  pickupNumber: vNonEmptyString(),
  message: vOptional(vString()),
})
export type ConfirmLoadDto = vOutput<typeof confirmLoadSchema>

export const editConfirmationNumberSchema = vObject({
  confirmationNumber: vNonEmptyString(),
})
export type EditConfirmationNumberDto = vOutput<
  typeof editConfirmationNumberSchema
>

export const toggleArchiveRequestSchema = vObject({
  archive: vBoolean(),
  carrierId: vOptional(vString()),
})
export type ToggleArchiveRequestDto = vOutput<typeof toggleArchiveRequestSchema>

export const publicShipmentTokenQuerySchema = vObject({
  token: vString(),
})
export type PublicShipmentTokenQuery = vOutput<
  typeof publicShipmentTokenQuerySchema
>
